export var ErrorPageType;
(function (ErrorPageType) {
    ErrorPageType[ErrorPageType["noOrders"] = 0] = "noOrders";
    ErrorPageType[ErrorPageType["loadingError"] = 1] = "loadingError";
})(ErrorPageType || (ErrorPageType = {}));
